// extracted by mini-css-extract-plugin
export var active = "_2e-c";
export var activeIndicator = "_2e-7";
export var animate = "_2e-b";
export var contentWidthTabs = "_2e-5";
export var disabled = "_2e-d";
export var flat = "_2e-1";
export var fullWidth = "_2e-3";
export var lg = "_2e-a";
export var md = "_2e-9";
export var redoButtonTabGroup = "_2e-0";
export var sm = "_2e-8";
export var tabButton = "_2e-4";
export var tabButtonsContainer = "_2e-2";
export var xs = "_2e-6";